import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Separator } from '../../../../../../CommonComponents/OPL/Separator/Separator';
import { AccountApplicantsDTO } from '../../../../api/useAccountApplicantsQuery';
import { FORM_ID, FormValues, validation } from './SummaryForm.meta';
import { PersonalInfo } from './components/PersonalInfo/PersonalInfo';

interface Props {
  data: AccountApplicantsDTO;
  onSubmit(values: FormValues): void;
  setIsFormDirty(isDirty: boolean): void;
}

export const SummaryForm: React.FC<Props> = ({
  data: { primaryApplicant, secondApplicant, accountType },
  setIsFormDirty,
  onSubmit,
}) => {
  const formBag = useForm<FormValues>({
    defaultValues: {
      primaryApplicant,
      secondApplicant,
    },
    resolver: yupResolver(validation),
    context: { accountType },
  });

  useEffect(() => {
    if (Object.keys(formBag.formState.dirtyFields).length === 0) {
      setIsFormDirty(false);
    } else {
      setIsFormDirty(true);
    }
  }, [formBag.formState, setIsFormDirty]);

  return (
    <FormProvider {...formBag}>
      <form id={FORM_ID} onSubmit={formBag.handleSubmit(onSubmit)}>
        <PersonalInfo
          title={
            secondApplicant
              ? `${primaryApplicant.firstName} ${primaryApplicant.lastName}`
              : 'Personal Information'
          }
          fieldName="primaryApplicant"
        />

        {secondApplicant && (
          <>
            <Separator my="24" />

            <PersonalInfo
              title={`${secondApplicant.firstName} ${secondApplicant.lastName}`}
              fieldName="secondApplicant"
            />
          </>
        )}
      </form>
    </FormProvider>
  );
};
